(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["siostra-stock-alert"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('siostra-stock-alert')) {
    customElements.define('siostra-stock-alert', class extends HTMLElement {
      connectedCallback() {
        if (this.listenerController) return;
        this.listenerController = new AbortController();
        this.selectionVersion = (this.selectionVersion || 0) + 1;
        this.alertForm = this.querySelector('[data-stock-alert-form]');
        this.productForm = document.getElementById(this.dataset.productForm);
        this.fields = this.querySelector('fieldset');
        this.status = this.querySelector('[data-stock-alert-status]');
        this.variantLabel = this.querySelector('[data-stock-alert-variant]');
        this.submitButton = this.querySelector('button[type="submit"]');
        this.endpoint = this.parseEndpoint(this.dataset.endpoint);
        this.productId = this.validId(this.dataset.productId);
        this.busy = false;
        this.completed = false;
        this.variantId = '';
        this.ready = false;
        this.hidden = true;
        this.setStatus('');
        if (!this.alertForm || !this.fields || !this.status || !this.variantLabel || !this.submitButton || this.productForm?.tagName !== 'FORM' || !this.endpoint || !this.productId) return;
        this.optionSignature = this.readOptionSignature();
        const signal = this.listenerController.signal;
        this.alertForm.addEventListener('submit', event => this.submit(event), { signal });
        this.productForm.addEventListener('variant:change', event => this.variantChanged(event), { signal });
        document.addEventListener('change', event => this.selectionChanged(event), { capture: true, signal });
        const initialId = this.validId(this.dataset.variantId);
        if (initialId && this.currentProductVariantId() === initialId) {
          this.variantId = initialId;
          this.ready = this.dataset.variantAvailable === 'false';
          this.setVariantLabel(this.dataset.variantTitle);
        }
        this.render();
      }

      disconnectedCallback() {
        this.listenerController?.abort();
        this.listenerController = null;
        this.cancelRequest();
        this.selectionVersion = (this.selectionVersion || 0) + 1;
      }

      validId(value) {
        const id = String(value ?? '');
        return /^[1-9]\d*$/.test(id) ? id : '';
      }

      parseEndpoint(value) {
        try {
          if (!/^https:\/\//i.test(value || '')) return null;
          const url = new URL(value);
          return url.protocol === 'https:' && url.hostname && !url.username && !url.password && !url.hash ? url.href : null;
        } catch {
          return null;
        }
      }

      currentProductVariantId() {
        return this.validId(this.productForm?.querySelector('input[name="id"]')?.value);
      }

      readOptionSignature() {
        return Array.from(document.querySelectorAll('input[data-option-position]'))
          .filter(input => input.form === this.productForm && input.checked)
          .map(input => `${input.dataset.optionPosition}:${input.value}`)
          .sort().join('|');
      }

      setVariantLabel(title) {
        this.variantLabel.textContent = this.dataset.hasDefaultVariant === 'true' || !title
          ? this.dataset.productTitle
          : `${this.dataset.productTitle} — ${title}`;
      }

      selectionChanged(event) {
        const input = event.target;
        if (!(input instanceof HTMLInputElement) || input.form !== this.productForm) return;
        if (input.hasAttribute('data-option-position')) {
          this.optionSignature = this.readOptionSignature();
          this.invalidateSelection();
        } else if (input.name === 'id') {
          this.invalidateSelection();
        }
      }

      invalidateSelection() {
        this.selectionVersion += 1;
        this.cancelRequest();
        this.ready = false;
        this.variantId = '';
        this.completed = false;
        this.setStatus('');
        this.render();
      }

      variantChanged(event) {
        if (event.target !== this.productForm) return;
        const variant = event.detail?.variant;
        const id = this.validId(variant?.id);
        this.invalidateSelection();
        if (!id || this.currentProductVariantId() !== id || this.readOptionSignature() !== this.optionSignature) return;
        this.variantId = id;
        this.ready = variant.available === false;
        this.setVariantLabel(variant.title);
        this.render();
      }

      setStatus(message, state = '') {
        if (!this.status) return;
        this.status.textContent = message || '';
        this.status.dataset.state = state;
        this.status.setAttribute('role', state === 'error' ? 'alert' : 'status');
      }

      render() {
        const eligible = Boolean(this.endpoint && this.productId && this.ready && this.variantId);
        this.hidden = !eligible;
        if (this.fields) this.fields.disabled = !eligible || this.busy || this.completed;
        this.submitButton?.setAttribute('aria-busy', String(this.busy));
      }

      cancelRequest() {
        if (this.requestTimer) clearTimeout(this.requestTimer);
        this.requestTimer = null;
        this.requestController?.abort();
        this.requestController = null;
        this.busy = false;
      }

      async submit(event) {
        event.preventDefault();
        if (this.busy || this.completed || !this.ready || !this.endpoint || !this.variantId) return;
        if (this.currentProductVariantId() !== this.variantId || this.readOptionSignature() !== this.optionSignature) {
          this.invalidateSelection();
          return;
        }
        const emailInput = this.alertForm.elements.namedItem('email');
        const consentInput = this.alertForm.elements.namedItem('consent');
        emailInput.value = emailInput.value.trim();
        if (!this.alertForm.reportValidity() || !consentInput.checked) return;
        if (typeof crypto.randomUUID !== 'function') {
          this.setStatus(this.dataset.errorMessage, 'error');
          return;
        }
        const email = emailInput.value;
        const identity = `${this.productId}:${this.variantId}:${email.toLowerCase()}`;
        if (this.requestIdentity !== identity) {
          this.requestIdentity = identity;
          this.requestId = crypto.randomUUID();
        }
        const payload = {
          email,
          product_id: this.productId,
          variant_id: this.variantId,
          consent: true,
          consent_version: 'siostra-restock-v1',
          website: this.alertForm.elements.namedItem('website').value,
          request_id: this.requestId
        };
        const version = this.selectionVersion;
        const controller = new AbortController();
        this.requestController = controller;
        this.busy = true;
        this.setStatus('');
        this.render();
        let timedOut = false;
        this.requestTimer = setTimeout(() => {
          timedOut = true;
          controller.abort();
        }, 15000);
        const isCurrent = () => this.isConnected && this.requestController === controller && this.selectionVersion === version;
        try {
          const response = await fetch(this.endpoint, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify(payload),
            credentials: 'omit',
            cache: 'no-store',
            redirect: 'error',
            referrerPolicy: 'no-referrer',
            signal: controller.signal
          });
          const result = await response.json();
          if (!isCurrent()) return;
          if (response.status === 202 && result?.ok === true && result.status === 'pending') {
            this.completed = true;
            this.setStatus(this.dataset.successMessage, 'success');
          } else if (response.status === 409 && result?.code === 'available') {
            this.completed = true;
            this.setStatus(this.dataset.availableMessage, 'error');
          } else if (response.status === 429) {
            this.setStatus(this.dataset.rateMessage, 'error');
          } else {
            this.setStatus(this.dataset.errorMessage, 'error');
          }
        } catch {
          if (isCurrent()) this.setStatus(timedOut ? this.dataset.timeoutMessage : this.dataset.errorMessage, 'error');
        } finally {
          if (isCurrent()) {
            clearTimeout(this.requestTimer);
            this.requestTimer = null;
            this.requestController = null;
            this.busy = false;
            this.render();
          }
        }
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
